import { EXERCISES } from 'apollo/queries';
import { useAuthQuery } from 'utils/hooks';

export const useGetExercises = () => {
  const { loading, data } = useAuthQuery(EXERCISES);
  const { exercises = [] } = { ...data };

  return { loading, exercises };
};
